export interface SingUpRequest {
  email: string;
  password: string;
  otp: string;
  confirmPassword: string;
}

export interface SingUpExternalProviderRequest {
  otp: string;
  idToken: string;
}

export enum SignUpResponseErrorEnum {
  RegistrationFailed = 'registration-failed',
}

export interface SignUpResponseError {
  errorCodes: string[] | SignUpResponseErrorEnum[];
  message: string;
  status: string;
}
